import React from 'react';

import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import RegisterInput from '../../components/input/RegisterInput';

import {
  TITLE_LOGIN_HERE,
  TITLE_LOGIN_HERE_EN,
  TITLE_REGISTER_HAVE_ACCOUNT,
  TITLE_REGISTER_HAVE_ACCOUNT_EN,
  TITLE_REGISTER_TITLE,
  TITLE_REGISTER_TITLE_EN,
  URL_LOGIN,
} from '../../utils/common/constant';
import { asyncRegisterUser } from '../../middleware/users/action';
import { SectionRegisterPage } from '../../components/styled';

const RegisterPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const locale = 'en';

  const onRegister = ({ name, email, password }) => {
    dispatch(asyncRegisterUser({ name, email, password }));
    navigate(URL_LOGIN);
  };

  return (

    <SectionRegisterPage>
      <h2>{locale === 'id' ? TITLE_REGISTER_TITLE : TITLE_REGISTER_TITLE_EN}</h2>
      <RegisterInput register={onRegister} />
      <p>
        {locale === 'id' ? TITLE_REGISTER_HAVE_ACCOUNT : TITLE_REGISTER_HAVE_ACCOUNT_EN}
        {' '}
        &nbsp;
        <Link to={URL_LOGIN}>{locale === 'id' ? TITLE_LOGIN_HERE : TITLE_LOGIN_HERE_EN}</Link>
      </p>
    </SectionRegisterPage>
  );
};

export default RegisterPage;
